//
//
//
//
//

import { mapState } from 'vuex'
import { showData } from '@/utils/mqtt'
import * as echarts from 'echarts'
import { EleResize } from '@/utils/esresize'

export default {
    props: {
        propValue: {
            type: String,
            require: true,
            default: '',
        },
        element: {
            type: Object,
            default: () => {},
        },
    },
    data() {
        return {
            showData,
            optiongauge: {
                title: {
                    text: this.element.propValue
                },
                tooltip: {},
                legend: {
                    show: this.element.style.legendShow,
                },
                toolbox: {
                    show: this.element.style.toolShow,
                    feature: {
                        dataZoom: {
                            yAxisIndex: 'none'
                        },
                        dataView: { readOnly: false },
                        magicType: { type: ['line', 'bar'] },
                        // restore: {},
                        saveAsImage: {},
                        myFull: { // 全屏
                            show: true,
                            title: '全屏',
                            icon: 'path://M432.45,595.444c0,2.177-4.661,6.82-11.305,6.82c-6.475,0-11.306-4.567-11.306-6.82s4.852-6.812,11.306-6.812C427.841,588.632,432.452,593.191,432.45,595.444L432.45,595.444z M421.155,589.876c-3.009,0-5.448,2.495-5.448,5.572s2.439,5.572,5.448,5.572c3.01,0,5.449-2.495,5.449-5.572C426.604,592.371,424.165,589.876,421.155,589.876L421.155,589.876z M421.146,591.891c-1.916,0-3.47,1.589-3.47,3.549c0,1.959,1.554,3.548,3.47,3.548s3.469-1.589,3.469-3.548C424.614,593.479,423.062,591.891,421.146,591.891L421.146,591.891zM421.146,591.891',
                            onclick: (e) => {
                                // 全屏查看
                                let domName = this.$refs.chartmaingauge
                                if (domName.requestFullScreen) { // HTML W3C 提议
                                domName.requestFullScreen()
                                } else if (domName.msRequestFullscreen) { // IE11
                                domName.msRequestFullScreen()
                                } else if (domName.webkitRequestFullScreen) { // Webkit
                                domName.webkitRequestFullScreen()
                                } else if (domName.mozRequestFullScreen) { // Firefox
                                domName.mozRequestFullScreen()
                                }
                                // 退出全屏
                                if (domName.requestFullScreen) {
                                document.exitFullscreen()
                                } else if (domName.msRequestFullScreen) {
                                document.msExitFullscreen()
                                } else if (domName.webkitRequestFullScreen) {
                                document.webkitCancelFullScreen()
                                } else if (domName.mozRequestFullScreen) {
                                document.mozCancelFullScreen()
                                }
                            }
                        }
                    }
                },
                series: [{
                    type: 'gauge', //设置图表主题
                    progress: {
                        show: true
                    },
                    detail: {
                        valueAnimation: true,
                        formatter: '{value}'
                    },
                    data: [
                        { value: 60,name: 'SCORE' }
                    ],
                    label: {
                        show: this.element.style.labelShow
                    },
                    name: this.element.style.sname
                }],
            },
            chartmaingauge: null
        }
    },
    computed: {
        ...mapState([
            'editMode',
        ]),
    },
    mounted() {
       this.drawLine()
       window.refreshGauge = this.refreshGauge
    },
    methods: {
        drawLine() {
            // 基于准本好的DOM，初始化echarts实例
            this.chartmaingauge = echarts.init(this.$refs.chartmaingauge, this.element.style.mode ? 'dark' : 'light')
            // 绘制图表
            this.chartmaingauge.setOption(this.optiongauge)
            // 自适应
            let self = this
            var listener = function() {
                self.chartmaingauge.resize()
            }
            EleResize.on(this.$refs.chartmaingauge, listener)
        },
        refreshGauge() {
            if(this.editMode == 'show') {
                if(this.showData.hasOwnProperty(this.element.events.subscribeTopic)) {
                    let data = this.showData[this.element.events.subscribeTopic].data
                    this.chartmaingauge.setOption({
                        series:[{
                            type: 'gauge', //设置图表主题
                            data: data,
                        }],
                    });
                }
            }
        }
    },
}
